import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-a8a74f4e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "PriceCalculateQuestionEditorContainer"
};
const _hoisted_2 = {
  class: "mr16"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "A", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "B", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "C", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "D", -1));
const _hoisted_7 = {
  key: 1,
  class: "flex items-center justify-center mt16 wd100",
  style: {
    "height": "400px",
    "border": "#1388ff 1px dashed"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_row = _resolveComponent("el-row");
  const _component_PriceCalculateImage = _resolveComponent("PriceCalculateImage");
  const _component_PriceCalculateQuestionSelector = _resolveComponent("PriceCalculateQuestionSelector");
  const _component_el_drawer = _resolveComponent("el-drawer");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.questions, (q, qi) => {
    return _openBlock(), _createElementBlock(_Fragment, {
      key: qi
    }, [q != null ? (_openBlock(), _createBlock(_component_el_row, {
      key: 0,
      class: "wbg mt12 pd12 flex flex-col",
      style: {
        "border": "#1388ff 1px dashed"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_el_row, {
        class: "ft14"
      }, {
        default: _withCtx(() => [_createElementVNode("span", _hoisted_2, "第" + _toDisplayString(qi + 1) + "题 ", 1), _createVNode(_component_el_button, {
          size: "small",
          type: "primary",
          onClick: $event => $options.toAdd(qi)
        }, {
          default: _withCtx(() => [_createTextVNode("换题")]),
          _: 2
        }, 1032, ["onClick"])]),
        _: 2
      }, 1024), _createVNode(_component_el_row, null, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(q.questions, (q, qi) => {
          return _openBlock(), _createBlock(_component_PriceCalculateImage, {
            key: `sq_${qi}`,
            data: q
          }, null, 8, ["data"]);
        }), 128))]),
        _: 2
      }, 1024), _createVNode(_component_el_row, {
        style: {
          "align-items": "flex-end"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, {
          class: "flex flex-col flex items-center justify-center"
        }, {
          default: _withCtx(() => [_createVNode(_component_PriceCalculateImage, {
            data: q.optionA
          }, null, 8, ["data"]), _hoisted_3]),
          _: 2
        }, 1024), _createVNode(_component_el_row, {
          class: "flex flex-col flex items-center justify-center"
        }, {
          default: _withCtx(() => [_createVNode(_component_PriceCalculateImage, {
            data: q.optionB
          }, null, 8, ["data"]), _hoisted_4]),
          _: 2
        }, 1024), _createVNode(_component_el_row, {
          class: "flex flex-col flex items-center justify-center"
        }, {
          default: _withCtx(() => [_createVNode(_component_PriceCalculateImage, {
            data: q.optionC
          }, null, 8, ["data"]), _hoisted_5]),
          _: 2
        }, 1024), _createVNode(_component_el_row, {
          class: "flex flex-col flex items-center justify-center"
        }, {
          default: _withCtx(() => [_createVNode(_component_PriceCalculateImage, {
            data: q.optionD
          }, null, 8, ["data"]), _hoisted_6]),
          _: 2
        }, 1024)]),
        _: 2
      }, 1024), _createElementVNode("span", null, "答案：" + _toDisplayString(q.rightAnswer), 1)]),
      _: 2
    }, 1024)) : (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_el_button, {
      size: "large",
      type: "primary",
      onClick: $event => $options.toAdd(qi)
    }, {
      default: _withCtx(() => [_createTextVNode("添加试题")]),
      _: 2
    }, 1032, ["onClick"])]))], 64);
  }), 128))]), _createVNode(_component_el_drawer, {
    modelValue: $data.drawer,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.drawer = $event),
    title: "选择题目",
    size: "1000px",
    "with-header": false
  }, {
    default: _withCtx(() => [_createVNode(_component_PriceCalculateQuestionSelector, {
      onConfirm: $options.onSelected
    }, null, 8, ["onConfirm"])]),
    _: 1
  }, 8, ["modelValue"])], 64);
}